import { render, staticRenderFns } from "./shu.vue?vue&type=template&id=02f534d8&scoped=true"
import script from "./shu.vue?vue&type=script&lang=js"
export * from "./shu.vue?vue&type=script&lang=js"
import style0 from "./shu.vue?vue&type=style&index=0&id=02f534d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f534d8",
  null
  
)

export default component.exports